export const getGitCommitHash = () =>
  (import.meta.env["VITE_GIT_COMMIT_HASH"] as string) || undefined;
